<rt-anonymous-info-bar
  [anonymousStage]="firstAnonymousCandidateStage()"
  [noRadius]="!hasBorderRadius()"
>
  <div rightSlot layout layout-align-items-center layout-flex-0-0>
    @if (everRevealedFor()?.length) {
      <rt-anonymous-revealed-for [users]="everRevealedFor()" margin-right-small />
    }
    <div>
      <rt-reveal-button
        *rtAbilityGuard="Ability.RevealAnonymousCandidates"
        rtCandidateDataVisibilityAnalytics
        variant="outline-informative"
        size="small"
        [candidate]="candidate()"
        [skipConfirmation]="candidateDataVisibilityService.shouldSkipRevealConfirmation()"
        (toggleDataVisibility)="
          candidateDataVisibilityService.toggleDataVisibility(candidate().id, $event)
        "
        (saveDontAskAgain)="candidateDataVisibilityService.saveDontAskForConfirmationAgain()"
      />
    </div>
  </div>
</rt-anonymous-info-bar>
